module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "index-container"
  }, [_c('div', {
    staticClass: "ic-banner"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "ic-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "userBox"
  }, [_c('el-menu', {
    staticClass: "docMenu",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("index.documentation")))])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "../../static/apidoc/docs.html",
      "target": "_blank"
    }
  }, [_vm._v("API")])]), _vm._v(" "), _c('el-submenu', {
    staticClass: "subMenu",
    attrs: {
      "index": "1-2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("SDK")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-js-sdk",
      "target": "_blank"
    }
  }, [_vm._v("JavaScript")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain/iWan-java-sdk",
      "target": "_blank"
    }
  }, [_vm._v("Java")])])], 2)], 2)], 1), _vm._v(" "), _c('i', {
    staticClass: "line-w"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.login")))]), _vm._v(" "), _c('i', {
    staticClass: "line-w"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "register"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.signup")))]), _vm._v(" "), _c('i', {
    staticClass: "line-w"
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.langToggle
    }
  }, [_vm._v(_vm._s(_vm.$t("index.lang")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "icb-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("index.gatewayTitle")))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("index.gatewayInfo")))])]), _vm._v(" "), _c('router-link', {
    staticClass: "freeBtn",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t("index.signup")))]), _vm._v(" "), _vm._m(2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ic-article"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("index.benefitTitle")))]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "why-container"
  }, [_c('dl', [_vm._m(4), _vm._v(" "), _c('dd', [_c('h5', [_vm._v(_vm._s(_vm.$t("index.benefit1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("index.benefit1info")))])])]), _vm._v(" "), _c('dl', [_vm._m(5), _vm._v(" "), _c('dd', [_c('h5', [_vm._v(_vm._s(_vm.$t("index.benefit2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("index.benefit2info")))])])]), _vm._v(" "), _c('dl', [_vm._m(6), _vm._v(" "), _c('dd', [_c('h5', [_vm._v(_vm._s(_vm.$t("index.benefit3")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("index.benefit3info")))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "he-container"
  }, [_c('div', {
    staticClass: "w"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("index.summary")))]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('iFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginImg"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    attrs: {
      "src": require("../../assets/img/line.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ico"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "https://t.me/WanchainANN"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/tm.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://twitter.com/wanchain_org"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/f3.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/wanchainfoundation/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/f5.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://github.com/wanchain"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/f9.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "mailto:techsupport@wanchain.org"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/f11.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://weibo.com/wanchain"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/web.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "webcat"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/webcat.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "weiCode",
    attrs: {
      "src": require("../../assets/img/wechatEn.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qq"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/qq.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "qqCode",
    attrs: {
      "src": require("../../assets/img/qqer.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "line-p"
  }, [_c('i', {
    staticClass: "com-line2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('img', {
    attrs: {
      "src": require("../../assets/img/wci.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('img', {
    attrs: {
      "src": require("../../assets/img/wci2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('img', {
    attrs: {
      "src": require("../../assets/img/wci3.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "line-p"
  }, [_c('i', {
    staticClass: "com-line2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('img', {
    staticClass: "bit",
    attrs: {
      "src": require("../../assets/img/bit.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "eth",
    attrs: {
      "src": require("../../assets/img/eth.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eac87c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index/Index.vue
// module id = 974
// module chunks = 1